export default Object.freeze({
  ACTIVE: 'active',
  DELETED: 'deleted',
  PENDING: 'pending'
})
